import { ArrowLeft, MoreHorizontal } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { api } from "../lib/api";

export function NotificationsPage() {
  const notifications = useApi(api.notifications, []);
  return (
    <section className="phone-page notifications-page">
      <header className="phone-head"><a href="/" aria-label="Back"><ArrowLeft /></a><h1>Notifications</h1><button aria-label="More"><MoreHorizontal /></button></header>
      <div className="notification-list">
        {notifications.data?.map((item) => (
          <a className="notification-item" href={item.postId ? `/p/${item.postId}` : item.actor ? `/@${item.actor.username}` : "/notifications"} key={item.id}>
            <img src={item.actor?.avatarUrl || "/assets/floptropica-one-logo.png"} alt="" />
            <p><strong>{item.actor?.displayName || "Floptropica One"}</strong> {item.body || copyFor(item.type)}<span>{relativeDate(item.createdAt)}</span></p>
            {item.type === "follow" ? <button>Follow</button> : <i />}
          </a>
        ))}
        {notifications.data?.length === 0 && <div className="state">No notifications yet.</div>}
      </div>
    </section>
  );
}

function copyFor(type: string): string {
  if (type === "follow") return "started following you";
  if (type === "like") return "liked your post";
  if (type === "comment") return "commented on your post";
  if (type === "mention") return "mentioned you";
  return "sent you an update";
}

function relativeDate(value: string): string {
  const diff = Date.now() - new Date(value).getTime();
  const minutes = Math.max(1, Math.floor(diff / 60000));
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return days === 1 ? "Yesterday" : `${days} days`;
  return new Intl.DateTimeFormat(undefined, { day: "numeric", month: "short" }).format(new Date(value));
}
